import {Injectable} from '@angular/core';
import {environment} from './../../../environments/environment';
import {HttpRequestService} from './../../shared/services/http-request.service';
import {DashboardPDModel} from './../../models/dashboard/dashboard.model';
import {Observable} from "rxjs";
import {ResponseContentType} from "@angular/http";
import {HttpClient} from "@angular/common/http";
import {ObservableInput} from "rxjs/Observable";

@Injectable()
export class DashboardService {

  private getPageDataUrl = environment.apiUrl + '/Dashboard/GetDashboardPDModel';
  private getMenuDataUrl = environment.apiUrl + '/Dashboard/GetMenuData';
  private getLogUrl = environment.apiUrl + '/Survey/GetActionLog';

  constructor(private http: HttpRequestService, private httpClient: HttpClient) {
  }

  getPageData() {
    return this.http.get(this.getPageDataUrl, false);
  }

  getMenuData(){
    return this.http.get(this.getMenuDataUrl, false);
  }

  getActionLog(){
    return this.http.get(this.getLogUrl, false);
  }

}



// WEBPACK FOOTER //
// ./src/app/routes/dashboard/dashboard.service.ts